<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{menuGroupCatalogManageInfo.catalogName}}
              <span>{{$t('menuGroupCatalogManage.menuGroup')}}</span>
            </span>
            <div>
              <el-button type="primary" size="small" @click="_openAddMenuGroupCatalogModal()">
                <i class="el-icon-plus"></i>添加
              </el-button>
              <el-button type="default" size="small" @click="_goBack()">
                返回
              </el-button>
            </div>
          </div>
          <div class="table-container">
            <el-table
              :data="menuGroupCatalogManageInfo.menuGroupCatalogs"
              style="width: 100%"
              border
              stripe>
              <el-table-column
                prop="gcId"
                :label="$t('menuGroupCatalogManage.number')"
                align="center"
                width="120">
              </el-table-column>
              <el-table-column
                prop="mgName"
                :label="$t('menuGroupCatalogManage.menuGroup')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="gId"
                :label="$t('menuGroupCatalogManage.menuGroupId')"
                align="center"
                width="180">
              </el-table-column>
              <el-table-column
                :label="$t('menuGroupCatalogManage.operation')"
                align="center"
                width="180">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="_openDeleteMenuGroupCatalogModel(scope.row)">
                      {{$t('menuGroupCatalogManage.delete')}}
                    </el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="menuGroupCatalogManageInfo.total">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-menu-group-catalog ref="addMenuGroupCatalog"></add-menu-group-catalog>
    <delete-menu-group-catalog ref="deleteMenuGroupCatalog"></delete-menu-group-catalog>
  </div>
</template>

<script>
import { listMenuGroupCatalog } from '@/api/dev/menuGroupCatalogApi'
import AddMenuGroupCatalog from '@/components/dev/addMenuGroupCatalog/addMenuGroupCatalog'
import DeleteMenuGroupCatalog from '@/components/dev/deleteMenuGroupCatalog/deleteMenuGroupCatalog'

export default {
  name: 'MenuGroupCatalogManage',
  components: {
    AddMenuGroupCatalog,
    DeleteMenuGroupCatalog
  },
  data() {
    return {
      menuGroupCatalogManageInfo: {
        menuGroupCatalogs: [],
        total: 0,
        catalogName: '',
        conditions: {
          caId: '',
          gId: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.menuGroupCatalogManageInfo.catalogName = this.$route.query.catalogName
    this.menuGroupCatalogManageInfo.conditions.caId = this.$route.query.caId
    this._listMenuGroupCatalogs(this.currentPage, this.pageSize)
  },
  methods: {
    async _listMenuGroupCatalogs(page, rows) {
      try {
        const params = {
          ...this.menuGroupCatalogManageInfo.conditions,
          page,
          row: rows
        }
        const res = await listMenuGroupCatalog(params)
        this.menuGroupCatalogManageInfo.menuGroupCatalogs = res.data
        this.menuGroupCatalogManageInfo.total = res.total
      } catch (error) {
        console.error('获取菜单组目录列表失败:', error)
      }
    },
    _openAddMenuGroupCatalogModal() {
      this.$refs.addMenuGroupCatalog.open()
    },
    _openDeleteMenuGroupCatalogModel(row) {
      this.$refs.deleteMenuGroupCatalog.open(row)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listMenuGroupCatalogs(this.currentPage, this.pageSize)
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.table-container {
  margin-top: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
</style>